import CloseIcon from '@icons/CloseIcon';
import {
	Box,
	Button,
	ButtonProps,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	Slide,
	styled,
	useMediaQuery,
	useTheme
} from '@mui/material';
import {TransitionProps} from '@mui/material/transitions';
import React, {forwardRef, ReactElement, Ref, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {ICompetition} from '../../ICompetitions';
import bg from './assets/images/t0/bg-new.webp';
import desc from './assets/images/t0/desc.webp';
import info from './assets/images/t0/info.webp';
import line from './assets/images/t0/line.webp';
import ramezan from './assets/images/t0/ramezan.webp';
import start from './assets/images/t0/start.webp';
import winner from './assets/images/t0/winner.webp';

type IProps = {
	competition: ICompetition;
	referrer: string;
};

const Transition = forwardRef(function Transition(
	props: TransitionProps & {children: ReactElement<any, any>},
	ref: Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const ColorButton = styled(Button)<ButtonProps>(() => ({
	color: 'white',
	backgroundColor: 'rgb(232 190 115)',
	'&:hover': {
		backgroundColor: 'rgb(232 190 115)'
	}
}));
const allowedHours: number[] = [22];
const minutes: number[] = [25, 33, 45];
const allowedDays: number[] = [10, 11, 12, 15, 17, 27, 28, 29];
// const allowedDays: number[] = [13];

export default function TekyehmajaziCompetition({competition, referrer}: IProps) {
	const {t} = useTranslation();
	const theme = useTheme();
	const [open, setOpen] = useState(false);
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const [isActive, setIsActive] = useState(false);
	
	// Function to check time conditions dynamically
	const checkTime = () => {
		const now = new Date();
		const currentDate = now.getDate();
		const currentHours = now.getHours();
		const currentMinutes = now.getMinutes();
		
		const isSpecialDate = allowedDays.includes(currentDate);
		const isAllowedHour = allowedHours.includes(currentHours);
		const lastMinute = Math.max(...minutes);
		
		// Ensures the minute is between 0 and (lastMinute + 5)
		const isAllowedMinutes = currentMinutes >= 0 && currentMinutes <= lastMinute + 14;
		
		const newIsActive = isSpecialDate && isAllowedHour && isAllowedMinutes;
		// Only update state if it has changed to prevent unnecessary renders
		if (newIsActive !== isActive) {
			setIsActive(newIsActive);
		}
	};
	
	// Run check on mount and update every 15 seconds
	useEffect(() => {
		checkTime();
		const interval = setInterval(checkTime, 15000);
		return () => clearInterval(interval);
	}, []);
	
	const handleClickOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	
	return (
		<div className="w-full">
			<Dialog
				fullScreen={fullScreen}
				open={open}
				onClose={handleClose}
				scroll="paper"
				TransitionComponent={Transition}
				keepMounted
				aria-labelledby="responsive-dialog-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle id="responsive-dialog-title">{t('competitions.conditions')}</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={handleClose}
					sx={{position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500]}}
				>
					<CloseIcon/>
				</IconButton>
				<DialogContent dividers>
					<DialogContentText dangerouslySetInnerHTML={{__html: competition.description as string}}/>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleClose}>
						{t('competitions.understood')}
					</Button>
				</DialogActions>
			</Dialog>
			
			<Box
				className="w-fit h-[calc(100vh-55px)] overflow-y-scroll justify-center align-middle relative bg-[#004D43]"
				sx={{
					// backgroundImage: `url(${bg})`,
					// backgroundRepeat: 'no-repeat',
					// backgroundSize: 'cover'
				}}
			>
				<div className="flex flex-row w-full justify-center relative z-0">
					<img src={bg} alt="title"/>
				</div>
				{/*<div className="content flex flex-col h-fit content-around justify-center items-center relative z-50 mt-[30%] gap-y-10 bg-red-400">*/}
				<div
					className="content flex flex-col h-[70%] content-around justify-center items-center absolute bottom-0 left-1/2 translate-x-[-50%] w-full p-5 gap-y-10"
				>
					<div className={'w-8/12'}>
						<img src={ramezan} alt="ramezan"/>
						<img src={line} alt="ramezan"/>
					</div>
					<div className={'w-8/12'}>
						<img src={desc} alt="desc"/>
					</div>
					{isActive && (
						<div className="flex flex-row w-full justify-around">
							<Link to={`/tekyehmajazi`} className="scaleAnimate">
								<img src={start} alt="start" className={'w-fit h-8'}/>
							</Link>
						</div>
					)}
					<div className={'flex row gap-x-5'}>
						<img src={info} alt="info" onClick={handleClickOpen} className={'w-fit h-8 cursor-pointer'}/>
						<Link to={`/network/35`}>
							<img src={winner} alt="info" className={'w-fit h-8 cursor-pointer'}/>
						</Link>
					</div>
					{/*<Divider className="h-10"/>*/}
					{/*<div>*/}
					{/*	<img src={gifts} alt="gifts"/>*/}
					{/*</div>*/}
				</div>
			</Box>
		</div>
	);
}
